import React, { HTMLAttributes } from 'react'

export default function Suppress({ className = '', ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={`data-hj-suppress rr-block ${className}`} {...props} />
}
